import React from 'react'
import './index.css'
import View from 'components/View'
import ProductAOVLockIcon from 'components/ProductAOVLockIcon'
import useSelector from 'hooks/use-selector'
import { shouldShowAOVLockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-lock'

/**
 * @param {ProductVariantCollection} productVariant
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductCardAOVLockIcon ({ productVariant }) {
  const shouldShowAovLock = useSelector(
    shouldShowAOVLockProductVariantSelector({
      productVariant
    })
  )

  if (!shouldShowAovLock) {
    return <></>
  }

  return (
    <View className='product-card-aov-lock-icon'>
      <ProductAOVLockIcon />
    </View>
  )
}
